<template>
  <div id="app" :class="isMobile?'mobile-class':'web-class'">
    <Header class="header-fixed" v-if="$route.meta.requireHeader" style="flex-shrink: 0;"></Header>
    <!-- <div class="blank-top" style="height: 32px;"></div> -->
    <Header2 class="header2" v-if="$route.meta.requireHeader2"></Header2>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" style="flex-grow:1;" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" style="flex-grow:1;"></router-view>
    <Footer v-if="$route.meta.requireFooter" style="flex-shrink: 0;"></Footer>
  </div>
</template>
<script>
import Header from "./components/index/header";
import Header2 from "./components/index/header2";
import Footer from "./components/index/footer";
import utils from "./utils/fun";
export default {
  data() {
    return {
      isMobile: false
    };
  },
  components: {
    Header,
    Header2,
    Footer
  },
  mounted() {
    this.isMobile = Boolean(utils.isMobile());
  }
};
</script>
<style lang="scss">
#app {
  /* font: 12px/1.5 tahoma, arial, "Hiragino Sans GB", "Microsoft Yahei",
    \5b8b\4f53; */
  font-family: "Microsoft YaHei", Arial, Helvetica, sans-serif;
  background: #ffffff;
  color: #333333;
  font-size: 12px;
  line-height: 25px;
  display: flex;
  flex-direction: column;
  /* overflow: hidden; */
}
.web-class {
  height: 100%;
  min-width: 960px;
}

.header-fixed {
  position: fixed;
  top: 0;
  width: 100%;
  height: 32px;
  z-index: 1000;
}

.header2 {
  flex-shrink: 0;
  margin-top: 32px;
}
</style>
